module.exports = __webpack_public_path__ + "static/houzz-2844a37cf0297b6415018f770277473a.png";